// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JyJ1","footer":"styles_footer__3vvxW"};